import { ref } from 'vue';
import axios from 'axios';

export function useAvailability(apiUrl) {
    const dates   = ref({});
    const loading = ref(false);
    const error   = ref(null);

    // variantOnly asks for this package's own dates rather than its family's folded cheapest,
    // for a family whose variant_choice is 'customer' and whose option has been picked.
    // Package-only server-side; harmless on the other two types, which have no families.
    async function fetchDates(type, id, locationId, month, people = 1, variantOnly = false) {
        loading.value = true;
        error.value   = null;

        try {
            const response = await axios.get(apiUrl, {
                params: { type, product_id: id, location_id: locationId, month, people, variant_only: variantOnly ? 1 : 0 },
            });
            dates.value = response.data.dates;
        } catch {
            error.value = 'Could not load availability. Please try again.';
            dates.value = [];
        } finally {
            loading.value = false;
        }
    }

    return { dates, loading, error, fetchDates };
}
